import numeral from 'numeral'
import getPriceMinTick from 'utils/getPriceMinTick'
import getPriceAccuracy from 'utils/getPriceAccuracy'
import getFixedPriceWithMinTick from 'utils/getFixedPriceWithMinTick'

// 根据价格获取接近的最小变动价格梯度，price需要number类型
export function getNearbyPrice(price, minTicks) {
  const step = getPriceMinTick(price, minTicks)
  const accuracy = getPriceAccuracy(step)
  price = price.toFixed(accuracy)
  let div = Math.floor(
    numeral(price)
      .divide(step)
      .value()
  )
  const priceByStep = numeral(div)
    .multiply(step)
    .value()
  // 小数求余有精度问题，借用numeral实现求余数
  const mod = numeral(price)
    .subtract(priceByStep)
    .value()
  if (mod === 0) {
    return +price
  }
  // 间隔step就近取值，余数大于步长和余数差，向上取
  if (mod > step - mod) {
    div++
  }
  return numeral(div)
    .multiply(step)
    .value()
}

// 根据当前价格获取下一个步长价格，设计价格边界步长会变化
export function getNextPrice(price, minTicks, isUS, isAdd) {
  let step = getPriceMinTick(price, minTicks)
  let nextPrice = price
  // 美股需要以目标价小数单位为准
  if (isAdd) {
    nextPrice = numeral(price)
      .add(step)
      .value()
    if (isUS) step = getPriceMinTick(nextPrice, minTicks)
    nextPrice = numeral(price)
      .add(step)
      .value()
  } else {
    nextPrice = numeral(price)
      .subtract(step)
      .value()
    if (isUS) step = getPriceMinTick(price - step, minTicks)
    nextPrice = numeral(price)
      .subtract(step)
      .value()
  }
  return getFixedPriceWithMinTick(nextPrice, step, true)
}

// 根据最新价变化，计算获取价格边界变化次数
export function getOffsetCount(curPrice, lastPrice, minTicks, isUS) {
  const curStep = getPriceMinTick(curPrice, minTicks)
  const lastStep = getPriceMinTick(lastPrice, minTicks)
  // 价格在相同步长区间直接获取
  if (curStep === lastStep) {
    return numeral(curPrice)
      .subtract(lastPrice)
      .divide(curStep)
      .value()
  }
  let count = 0
  let price = curPrice
  if (curPrice < lastPrice) {
    while (price < lastPrice) {
      price = getNextPrice(price, minTicks, isUS, true)
      count++
    }
  } else {
    while (price > lastPrice && price > 0) {
      price = getNextPrice(price, minTicks, isUS, false)
      count--
    }
  }
  return count
}
